<!--
 * @Descripttion: 进度条属性设置
 * @Author: zenghua.wang
 * @Date: 2021-12-17 11:29:13
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-01-11 11:11:17
-->
<template>
  <el-collapse
    v-model="collapse"
    accordion
  >
    <el-collapse-item
      name="1"
      :title="component.basic"
    >
      <config-base :data="data" />
    </el-collapse-item>

    <!-- 接口设置 -->
    <api-interface
      :data="data"
      :apis="main.apiTableList"
    >
      <template v-slot:extend>
        <config-field
          :data="data"
          :showType="showTypeList"
          :rename="false"
        />
        <config-filter :data="data" />
      </template>
    </api-interface>

    <el-collapse-item title="进度条设置">
      <!-- <el-form-item label="隐藏">
        <el-switch
          v-model="data.option.hide"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item> -->

      <el-form-item label="类型">
        <el-radio-group
          v-model="data.option.type"
          size="mini"
        >
          <el-radio-button label="line">线形</el-radio-button>
          <el-radio-button label="circle">环形</el-radio-button>
          <el-radio-button label="dashboard">仪表盘</el-radio-button>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="线宽">
        <el-input-number v-model="data.option.strokeWidth" />
      </el-form-item>

      <el-form-item label="进度条颜色">
        <el-color-picker
          v-model="data.option.stroke"
          :predefine="predefineColors"
        ></el-color-picker>
      </el-form-item>

      <el-form-item label="字体大小">
        <el-input-number v-model="data.option.fontSize" />
      </el-form-item>

      <el-form-item label="字体颜色">
        <el-color-picker
          v-model="data.option.color"
          :predefine="predefineColors"
        ></el-color-picker>
      </el-form-item>

      <!-- <el-form-item label="百分比">
        <el-input-number
          v-model="data.option.percentage"
          :max="100"
        />
      </el-form-item> -->
    </el-collapse-item>

    <!-- 权限设置 -->
    <config-auth :data="data" />
  </el-collapse>
</template>

<script>
import {
  predefineColors,
  component,
  theme
} from '@/dragComponents/model/default.js'

import configBase from '@/dragComponents/config/common/base.vue'
import configAuth from '@/dragComponents/config/common/auth.vue'
import apiInterface from '@/dragComponents/config/api/index.vue'
import configField from '@/dragComponents/config/common/field.vue'
import configFilter from '@/dragComponents/config/common/filter.vue'

export default {
  name: 'config-progress',
  components: {
    configBase,
    configAuth,
    configField,
    configFilter,
    apiInterface
  },
  inject: ['main', 'category'],
  props: ['data', 'collapse'],
  data() {
    return {
      theme: theme,
      predefineColors: predefineColors,
      component: component,
      showTypeList: [
        {
          label: '数值',
          value: 'value'
        }
        // {
        //   label: '标题',
        //   value: 'name',
        // },
      ]
    }
  }
}
</script>
